import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MenuModule } from 'primeng/menu';

import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarService } from './sidebar/sidebar.service';
import { FontAwesomeSharedModule } from '../_shared/modules/font-awesome.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerService } from './spinner/spinner.service';

@NgModule({
  imports: [
    CommonModule,
    SidebarModule,
    ProgressSpinnerModule,
    MenuModule,
    FontAwesomeSharedModule
  ],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    SpinnerComponent
  ],
  providers: [
    SidebarService, 
    SpinnerService
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    SpinnerComponent
  ]
})
export class LayoutModule { }